export default {
      id: "bluetooth-icon-usage",
      viewBox: "0 0 34 38",
      url: __webpack_public_path__ + "img/icons.svg#bluetooth-icon",
      toString: function () {
        return this.url;
      }
    }